module.exports = __webpack_public_path__ + "static/img/video-tutorial.9ee2a1a6.png";